var e = Object.defineProperty, m = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var i = (o, t, r) => t in o ? e(o, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[t] = r, u = (o, t) => {
  for (var r in t || (t = {}))
    f.call(t, r) && i(o, r, t[r]);
  if (n)
    for (var r of n(t))
      l.call(t, r) && i(o, r, t[r]);
  return o;
}, a = (o, t) => m(o, p(t));
import { jsx as d } from "react/jsx-runtime";
import { AddToCartButton as C } from "./AddToCartButton.js";
import h from "./QuantitySelector.js";
const T = ({
  addToCartAction: o,
  quantitySelectorAction: t,
  productInCart: r,
  layout: c
}) => /* @__PURE__ */ d("div", { id: "product-card-button", children: r ? /* @__PURE__ */ d(h, a(u({}, t), { layout: c })) : /* @__PURE__ */ d(C, { handleAddToCart: o }) });
export {
  T as ProductCardButton
};
